import { Pipe, PipeTransform } from '@angular/core';
import {Project} from '../../model/project';
import {Questionnaire} from '../../model/questionnaire';
import {Terminal} from '../../model/terminal';
import {Timestamp} from 'rxjs/internal/types';

@Pipe({
  name: 'date',
  pure: false // impure pipe, update value when we change language
})

export class DatePipe implements PipeTransform {

  constructor() {
  }

  public transform(value:(Project|Terminal|Questionnaire)[],term: string,key: string):any[] {
    if(value == null) {
      return;
    }

    let date2 = null;
    if(term.length !== 0) {
      const tmp = term+'T05:00:00';
      date2 = new Date(tmp);
    }
    return value.filter(item => {
      return Object.keys(item).some(() => {
        if(date2 != null) {
           if(item[key].includes(term)) {
             return true;
           }
           return false;
        }
        return true;
      });
    });
    /*return value.filter((item) => {
      if (item.hasOwnProperty(key)) {
         else {
          return true;
        }
      } else {
        return false;
      }*/
    // });
  }
}
